var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtherDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3062",
    "data-name": "Rectangle 3062",
    width: 16,
    height: 16,
    transform: "translate(1213 404)",
    fill: "#8a8a8a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "otherDotsIcon",
    transform: "translate(-1213 -404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M20.2,9.2a2,2,0,1,0-2,2A2.006,2.006,0,0,0,20.2,9.2Zm0,12a2,2,0,1,0-2,2A2.006,2.006,0,0,0,20.2,21.2Zm0-6a2,2,0,1,0-2,2A2.006,2.006,0,0,0,20.2,15.2Z",
    transform: "translate(1202.801 396.8)",
    fill: "#8a8a8a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherDotsIcon);
export default __webpack_public_path__ + "static/media/otherDotsIcon.8f2b48b7b8609bda7aaad216426bec0f.svg";
export { ForwardRef as ReactComponent };